import OverlayTips from "../OverlayTips";

function WorkSchedulePageOverlayTipsManager()
{
    PageOverlayTipsManager.call(this);
}

WorkSchedulePageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {
    addBaseTips: function()
    {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        this.add($("table.monthName").eqOrLast(0), {
            messageKey: "tips.work_schedule.month",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: -30
        });

        this.add($(".calendarTable").eqOrLast(1).find("tr").eq(1).find("td").eq(6), {
            messageKey: "tips.work_schedule.day",
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            offsetX: -5,
            offsetY: -5
        });
    }
});

export default WorkSchedulePageOverlayTipsManager;


// WEBPACK FOOTER //
// ./web/js/tips/managers/WorkSchedulePageOverlayTipsManager.js